// extracted by mini-css-extract-plugin
export var typingIndicator = "_pl-0";